
const MainRoutes = {
  path: '/main',
  component: () => import('@/layouts/full/FullLayout.vue'),
  meta: {
    requireAuth: true
  },
  redirect: '/main/verification',
  children: [
    {
      name: 'select-verification',
      path: '/main/verification/select',
      component: () => import('@/pages/pm-verification/select-verification.vue')
    },
    {
      name: 'ssn-verification',
      path: '/main/ssn-verification',
      component: () => import('@/pages/ssn-verification/ssn-verification.vue')
    },
    {
      name: 'card-verification',
      path: '/main/verification/card',
      component: () => import('@/pages/pm-verification/pm-verification.vue')
    }
  ]
  
};

export default MainRoutes;
